function sessionToken() {
  return typeof window === "undefined" ? "" : sessionStorage.getItem("syrakis_token") || "";
}

export function readSessionClaims() {
  try {
    const token = sessionToken();
    const encodedPayload = token.split(".")[1];
    if (!encodedPayload) return {};
    const base64 = encodedPayload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    return JSON.parse(window.atob(padded));
  } catch (_error) {
    return {};
  }
}

export function readSessionRole() {
  const claims = readSessionClaims();
  const role = String(claims.role || claims.role_slug || claims.roleSlug || claims.user?.role || "")
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, "_");
  return role === "super_admin" ? "superadmin" : role;
}
